// extracted by mini-css-extract-plugin
export var alignCenter = "_8b-d";
export var bannerShown = "_8b-6";
export var buttonContent = "_8b-0";
export var cardList = "_8b-1";
export var centerContent = "_8b-2";
export var chevron = "_8b-3";
export var closePanelButton = "_8b-k";
export var conversationContextContainer = "_8b-l";
export var conversationDetailContainer = "_8b-4";
export var detailWrapper = "_8b-7";
export var dropdownButton = "_8b-e";
export var dropdownTitle = "_8b-9";
export var fullHeight = "_8b-5";
export var hidden = "_8b-a";
export var icon = "_8b-b";
export var mergeSuggestionWrapper = "_8b-m";
export var panel = "_8b-i";
export var portalButtonsWrapper = "_8b-c";
export var right = "_8b-j";
export var tableSummaryContainer = "_8b-8";
export var tableSummaryHeader = "_8b-g";
export var threeDotsButton = "_8b-f";
export var wide = "_8b-h";